import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

type FindPlaylistParams = {
  userId: number;
  filters?: Record<string, any>;
};

const { useFind: useStudentPlaylists } = getCRUDHooks({
  entityName: 'userPlaylist',
  sharedCacheEntities: ['playlist', 'userPlaylistsList'],
  find: ({ userId, filters }: FindPlaylistParams) =>
    clientApi.getOCClient().helpers.user.users.id(userId).playlists.find(filters),
});

// eslint-disable-next-line import/prefer-default-export
export { useStudentPlaylists };
